import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05c791c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "is-flex is-flex-direction-column is-justify-content-space-evenly" }
const _hoisted_2 = { class: "is-flex is-flex-direction-column custom-amount-input" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "notification is-danger is-light mb-2" }
const _hoisted_5 = { class: "icon is-small" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "frame3-sub-title mb-3"
}
const _hoisted_8 = {
  key: 1,
  class: "frame3-sub-title mb-3"
}
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "frame3-sub-title mb-3" }
const _hoisted_11 = { class: "frame3-sub-title mt-3 mb-3" }
const _hoisted_12 = {
  key: 3,
  class: "ml-2 min-credit-amount"
}
const _hoisted_13 = {
  key: 4,
  class: "ml-2 min-credit-amount"
}
const _hoisted_14 = { class: "is-flex" }
const _hoisted_15 = ["placeholder", "disabled"]
const _hoisted_16 = { class: "amount-currency-symbol pl-2" }
const _hoisted_17 = {
  key: 5,
  class: "notification is-danger is-light"
}
const _hoisted_18 = {
  key: 6,
  class: "notification is-danger is-light"
}
const _hoisted_19 = {
  key: 7,
  class: "memo-container"
}
const _hoisted_20 = ["placeholder", "disabled"]
const _hoisted_21 = {
  key: 0,
  class: "notification is-danger is-light mt-2"
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "is-flex mt-3" }
const _hoisted_24 = { class: "switch-centered" }
const _hoisted_25 = { class: "switch" }
const _hoisted_26 = ["checked"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1))
const _hoisted_28 = { class: "ml-2 switch-centered" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = ["placeholder", "disabled"]
const _hoisted_31 = {
  key: 0,
  class: "notification is-danger is-light mt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_BankAccountItem = _resolveComponent("BankAccountItem")!
  const _component_RecipientItem = _resolveComponent("RecipientItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.transactionType === 'adminCredit')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, [
                _createVNode(_component_fa_icon, { icon: "triangle-exclamation" })
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.$gettext(
              "This is a pledge operation that creates new currency, not a transfer. The total money supply will increase."
            ) +
            " " +
            _ctx.$gettext("Use only for authorized and exceptional cases.")), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_ctx.directionTransfer === 'send')
              ? (_openBlock(), _createElementBlock("h2", _hoisted_7, _toDisplayString(_ctx.$gettext("From")), 1))
              : (_openBlock(), _createElementBlock("h2", _hoisted_8, _toDisplayString(_ctx.$gettext("To")), 1)),
            _createVNode(_component_BankAccountItem, {
              class: "mb-4",
              account: _ctx.account,
              showSubAccounts: false,
              disableDropDown: true
            }, {
              name: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.account.name()), 1)
              ]),
              _: 1
            }, 8, ["account"])
          ])),
      (_ctx.selectedRecipient && _ctx.transactionType !== 'reconversion')
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.transactionType === "adminCredit"
              ? _ctx.$gettext("Selected credit recipient")
              : _ctx.$gettext("To")), 1),
            (_ctx.selectedRecipient)
              ? (_openBlock(), _createBlock(_component_RecipientItem, {
                  key: 0,
                  recipient: _ctx.selectedRecipient,
                  hideAdminButton: true
                }, null, 8, ["recipient"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.$gettext("Amount")), 1),
      (_ctx.transactionType === 'topup' && _ctx.account?.minCreditAmount)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$gettext("Minimum credit amount: ")) + " " + _toDisplayString(_ctx.account?.minCreditAmount) + " " + _toDisplayString(_ctx.account?.curr || ""), 1))
        : _createCommentVNode("", true),
      (_ctx.transactionType === 'topup' && _ctx.account?.maxCreditAmount)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$gettext("Maximum credit amount: ")) + " " + _toDisplayString(_ctx.account?.maxCreditAmount) + " " + _toDisplayString(_ctx.account?.curr || ""), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_14, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.amount) = $event)),
          ref: "amountRequested",
          type: "number",
          min: "0",
          class: _normalizeClass(["input is-custom mb-2", {
            'is-danger': _ctx.errors.amount || _ctx.parentErrors,
          }]),
          id: "send-amount-input",
          placeholder: _ctx.$gettext('e.g. 50'),
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleAmountInput())),
          disabled: _ctx.config?.amount && _ctx.directionTransfer !== 'receive'
        }, null, 42, _hoisted_15), [
          [
            _vModelText,
            _ctx.amount,
            void 0,
            { number: true }
          ]
        ]),
        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.account?.curr), 1)
      ]),
      (_ctx.errors.amount)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.errors.amount), 1))
        : _createCommentVNode("", true),
      (_ctx.parentErrors)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.parentErrors), 1))
        : _createCommentVNode("", true),
      (_ctx.transactionType !== 'reconversion' && _ctx.transactionType !== 'topup')
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _withDirectives(_createElementVNode("textarea", {
              onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSenderMemoInput())),
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.senderMemo) = $event)),
              class: _normalizeClass(["custom-textarea textarea mt-1 mb-2", {
            'is-danger': _ctx.errors.senderMemo,
          }]),
              placeholder: _ctx.$gettext('Add a payment memo (optional)'),
              ref: "sendertMemo",
              disabled: _ctx.transactionType === 'paymentRequest'
            }, null, 42, _hoisted_20), [
              [_vModelText, _ctx.senderMemo]
            ]),
            (_ctx.errors.senderMemo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.errors.senderMemo), 1))
              : _createCommentVNode("", true),
            (
            _ctx.transactionType !== 'paymentRequest' &&
            !['requestPay', 'createRequestPay', 'adminCredit'].includes(
              _ctx.transactionType
            ) && _ctx.hasSplitMemoSupport
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("label", _hoisted_25, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isCopyMemo) = $event)),
                          checked: _ctx.isCopyMemo,
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleSwitch && _ctx.handleSwitch(...args)))
                        }, null, 8, _hoisted_26), [
                          [_vModelCheckbox, _ctx.isCopyMemo]
                        ]),
                        _hoisted_27
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$gettext("Use the same memo for the recipient")), 1)
                  ]),
                  (!_ctx.isCopyMemo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _withDirectives(_createElementVNode("textarea", {
                          onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleRecipientMemoInput())),
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.recipientMemo) = $event)),
                          class: _normalizeClass(["custom-textarea textarea mt-1 mb-1", {
                'is-danger': _ctx.errors.recipientMemo,
              }]),
                          placeholder: 
                _ctx.$gettext('Add a reference for the recipient (optional)')
              ,
                          ref: "recipientMemo",
                          disabled: _ctx.transactionType === 'requestPay'
                        }, "\n            ", 42, _hoisted_30), [
                          [_vModelText, _ctx.recipientMemo]
                        ]),
                        (_ctx.errors.recipientMemo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.errors.recipientMemo), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}